// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1V0ML","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1KBsF"};